'use strict';

angular.module('Services').factory('ClientsTable', function(Client, $filter, TableData, $location) {
    return function() {

        var getClients = function(paginationData) {
            var requestPagination = paginationData || {};
            tableOptions.inProgress = 'update-data';
            Client.getList(function(data) {
                tableOptions.info = data;
                tableOptions.inProgress = false;
            }, function(err) {
                tableOptions.inProgress = false;
            }, requestPagination);
        };

        var tableOptions = {
            'noPagination': false,
            'noHead': false,
            'noCheck': true,
            'noSort': false,
            'noTitles': false,
            'noFilters': false,
            'onApplyFilters': getClients,
            'onInitTable': getClients,
            'head': []
        };

        var orderOptions = ['email', 'firstName', 'lastName', 'actions'];

        var cellsOptions = {
            email: {
                viewName: 'email',
                title: 'Email',
                sortName: 'email',
                filterName: 'email'
            },
            firstName: {
                title: 'First Name',
                viewName: 'firstName',
                sortName: 'firstName'
            },
            lastName: {
                title: 'Last Name',
                viewName: 'lastName',
                sortName: 'lastName'
            },
            actions: {
                title: 'Actions',
                cellName: 'actions',
                cellType: 'buttons',
                noSort: true,
                filterType: 'buttons',
                typeCellClass: 'btn-cell nowrap'
            }
        };

        this.getTableOptions = function(options) {
            TableData.baseData(options, tableOptions, orderOptions, cellsOptions);
            return tableOptions;
        };
        this.updateTableData = getClients;
    }
});



// WEBPACK FOOTER //
// ./js/services/table-headers/ClientsTable.js